import React from "react";

const ResumeCard = ({
  title,
  subTitle,
  responsibilities = [],
  isExpanded = false,
  toggleExpand,
}) => {
  // Show all responsibilities if expanded, otherwise only show first 2
  const displayedResponsibilities = isExpanded
    ? responsibilities
    : responsibilities.slice(0, 2);

  return (
    <div className="w-full group flex">
      <div className="w-10 h-[6px] bgOpacity mt-16 relative">
        <span className="absolute w-4 h-4 rounded-full -top-2 -left-2 flex justify-center items-center bg-gradient-to-r from-[#4B006E] to-[#8A00D4] border-2 border-bodyColor"></span>
      </div>
      <div
        className="w-full bg-[#150c1c] rounded-lg p-10 flex flex-col justify-center gap-5 hover:-translate-y-[8px] hover:shadow-[0_0_15px_rgba(138,0,212,0.3)] transition-all duration-300 ease-in-out cursor-pointer"
        onClick={toggleExpand}
      >
        <div>
          <h3 className="font-display font-bold text-2xl text-[#8A00D4] mb-3">
            {title}
          </h3>
          <p className="font-sans font-medium text-lg text-grayText mb-5">
            {subTitle}
          </p>
        </div>

        <div className="transition-all duration-300 ease-in-out overflow-hidden">
          <ul className="list-disc list-inside space-y-3">
            {displayedResponsibilities.map((item, i) => (
              <li
                key={i}
                className="font-sans font-normal text-base text-lightText leading-relaxed"
              >
                {item}
              </li>
            ))}
          </ul>

          {/* Show toggle indicator only if there are more than 2 items */}
          {responsibilities.length > 2 && (
            <div className="mt-5 text-[#8A00D4] font-sans text-base flex items-center">
              {isExpanded ? "Show less" : "Show more"}
              <svg
                className={`w-5 h-5 ml-2 transform transition-transform duration-300 ${
                  isExpanded ? "rotate-180" : ""
                }`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResumeCard;
